import { render, staticRenderFns } from "./RedaktionOptions.vue?vue&type=template&id=613847aa&scoped=true&"
import script from "./RedaktionOptions.vue?vue&type=script&lang=js&"
export * from "./RedaktionOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613847aa",
  null
  
)

export default component.exports